import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import reportTemplateColumns from "./ReportTemplateColumns";
import DataGrid from "../../../core/components/data-grid/DataGrid";
import ApiService from "../../../core/service/api-service";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {Button, Switch, Space} from "antd";
import ReportTemplateCreateEditForm from "../ReportTemplateCreateEditForm";
import {useModal} from "../../../core/context/ModalContext";

export default function ReportTemplateGrid({})
{
    const {t} = useTranslation();
    const {setDataGridProps, queryModel, setData, setPaginationResult} = useDataGrid();
    const {openModal} = useModal()
    const [isAiMode, setIsAiMode] = useState(false)

    const initGridData = async () => {
        const response = isAiMode
            ? await ApiService.ReportAiTemplate.GetDataGrid(queryModel)
            : await ApiService.ReportTemplate.GetDataGrid(queryModel)
        setPaginationResult(response.pagination);
        setData(response.data)
    }

    useEffect(() => {
        initGridData()
    }, [queryModel.updateKey, isAiMode])

    useEffect(() => {
        setDataGridProps({
            rowKey: 'id',
            columns: reportTemplateColumns(t, isAiMode)
        })
    }, [isAiMode])

    return (
        <>
            <DataGrid
                title={() => (
                    <Space>
                        <Button
                            size={'small'}
                            onClick={() => {
                                openModal(
                                    isAiMode ? t('New AI Template') : t('New Report Template'),
                                    <ReportTemplateCreateEditForm isAiMode={isAiMode} />,
                                    () => {}
                                )
                            }}
                        >
                            {isAiMode ? t('New AI Template') : t('New Report Template')}
                        </Button>
                        <Switch
                            checked={isAiMode}
                            onChange={setIsAiMode}
                            checkedChildren={t('AI Mode')}
                            unCheckedChildren={t('AI Mode')}
                            size={'small'}
                        />
                    </Space>
                )}
                name={'report-template'}
            />
        </>
    )
}
